import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import './LockPayment.scss';
import PaymentActions, {
   isFetchingPaymentLock,
   isFetchingPaymentUrl,
   isOperationSuccess,
   isOperationFailure,
} from 'pgdb-data-layer/lib/Redux/PaymentRedux';
import M from 'materialize-css';
import { Icon } from '@material-ui/core';
import { LOCK_PAYMENT } from 'pgdb-data-layer/lib/Constants/PaymentTransaction';
import { ReCaptcha, loadReCaptcha } from 'react-recaptcha-v3';
import { has } from 'lodash';
import LockPaymentFailed from './LockPaymentFailed';
import Loading from '../../../Components/Loading';
import { getToken } from '../../../Session/SessionRedux';
import { getUserInfoData } from 'pgdb-data-layer/lib/Redux/UserInfoRedux';
import RegistrationPaymentPopup from '../RegistrationPayment/Components/RegistrationPaymentPopup';
import Navigator from '../../../Navigation/Navigator';

const LockPayment = ({
   token,
   isFetchingPaymentUrl,
   paymentDetails,
   getPaymentUrlRequest,
   getPaymentLockRequest,
   lockPaymentData,
   isFetchingPaymentLock,
   isFetchingPaymentLockSuccess,
   isFetchingPaymentLockFailure,
   userContactData,
}) => {
   const [isOpenInfo, setIsOpenInfo] = useState(false);
   const [isPaymentFailedPopup, setIsPaymentFailedPopup] = useState(false);
   const [recaptchaToken, setRecaptchaToken] = useState('');
   const [paymentResponse, setPaymentResponse] = useState(false);
   const [paymentFailed, setPaymentFailed] = useState(false);
   
   useEffect(() => {
      loadReCaptcha(process.env.REACT_APP_RECAPTCHA_KEY);
      if (!lockPaymentData || lockPaymentData.length === 0) {
         console.log("Fetching lock payment data...");
         userContactData.contactId && getPaymentLockRequest(userContactData.contactId, token);
      }
   }, [userContactData.contactId, token, lockPaymentData]);

   useEffect(() => {
      if (!isFetchingPaymentLock) {
         if (!isFetchingPaymentLockSuccess && isFetchingPaymentLockFailure) {
            M.toast({
               html: 'Unable to load payment data. Please try again after 1 minute.',
               classes: 'error',
            });
         }
      }
   }, [isFetchingPaymentLock, isFetchingPaymentLockSuccess, isFetchingPaymentLockFailure]);

   const updateToken = () => {
      // you will get a new token in verifyCallback
      recaptchaToken.execute();
   };

   const renderAmountTable = () => {
      // Show data from getPaymentLockRequest if available
      if (lockPaymentData && lockPaymentData.length > 0) {
         return (
            <div className="payment-details-section">
               <div className="placeholder-header">
                  <h5>Payment information</h5>
               </div>
               <div className="placeholder-content">
                  <ul>
                     <li>The table below outlines your outstanding fees.</li>
                     <li>Click 'Pay' to proceed with payment.</li>
                     <li>If this is not correct or you have any questions, please call the Registration and Licensing team on <a href="tel:0800743262" rel="nofollow">
                              0800 743 262
                           </a></li>
                  </ul>
               </div>
               
               <table className="fee-breakdown-table">
                  <thead>
                     <tr>
                        <th>Type Application</th>
                        <th>Licence Year</th>
                        <th>Fee</th>
                        <th>Amount</th>
                     </tr>
                  </thead>
                  <tbody>
                     {lockPaymentData.map((item, index) => (
                        <tr key={item.FeeRequestId || index}>
                           <td>{item.applicationCodeDescription}</td>
                           <td>{item.licenceYear || '-'}</td>
                           <td>{item.feeTypeCodeDescription}</td>
                           <td>${item.feeRequestLineAmount ? item.feeRequestLineAmount.toFixed(2) : '0.00'}</td>
                        </tr>
                     ))}
                  </tbody>
               </table>

               <div className="total-section">
                  <div className="total-row">
                     <span>Total balance to pay:</span>
                     <span>NZD ${lockPaymentData.reduce((total, item) => total + (item.feeRequestLineAmount || 0), 0).toFixed(2)}</span>
                  </div>
               </div>
               <div className="table-clause-container">
                  <p className="table-clause-text">
                     * This amount incl. GST and excl. payment fees.
                  </p>
               </div>
            </div>
         );
      }
      if (isFetchingPaymentLock) {
         return (
            <div className="spinner-container">
               <Icon className="loading-button" />
               <p>Loading lock payment options...</p>
            </div>
         );
      }
      return null;
   };

   const displayPaymentPopup = () => {
      // closes open payment popup, or opens closed payment popup
      setIsOpenInfo(!isOpenInfo);
   };

   const displayPaymentFailedPopup = () => {
      setIsPaymentFailedPopup(!isPaymentFailedPopup);
   };

   const getPoliPayment = () => {
      setPaymentResponse(true);
      getPaymentUrlRequest(
         {
            urlFail: `${window.location.origin.toString()}/lock-payment?payment-fail`,
            urlCancel: `${window.location.origin.toString()}/lock-payment?payment-fail`,
            urlSuccess: `${window.location.origin.toString()}/payment-success/lock-payment-success?paymentType=PoliPayment`,
            createLicence: false,
            contactId: userContactData.contactId,
            transactionType: LOCK_PAYMENT,
            paymentType: 'PoliPayment',
         },
         recaptchaToken
      );
      displayPaymentPopup();
   };

   const getWindcavePayment = () => {
         
      setPaymentResponse(true);
      getPaymentUrlRequest(
         {
            urlFail: `${window.location.origin.toString()}/lock-payment/?payment-fail`,
            urlSuccess: `${window.location.origin.toString()}/payment-success/lock-payment-success`,
            createLicence: false,
            contactId: userContactData.contactId,
            transactionType: LOCK_PAYMENT,
         },
         recaptchaToken
      );
      displayPaymentPopup();
   };

   useEffect(() => {
      const result = new URLSearchParams(window.location.search);
      if (result.has('payment-fail')) {
         setPaymentFailed(true);
         displayPaymentFailedPopup();
      }
   }, []);

   useEffect(() => {
      if (paymentResponse && has(paymentDetails, 'isError')) {
         if (!paymentDetails.isError) {
            window.location = paymentDetails.response;
         } else {
            M.toast({
               html: `Sorry we couldn't process the payment.`,
               classes: 'error',
            });
            setPaymentFailed(true);
            displayPaymentFailedPopup();
            setPaymentResponse(false);
         }
      }
   }, [paymentDetails, paymentResponse]);

   const verifyCallback = recaptchaToken => {
      setRecaptchaToken(recaptchaToken);
   };

   return (
      <main>
         <Loading isLoading={isFetchingPaymentUrl}>
            <div className="section no-pad-bot" id="index-banner">
               <div className="container lock-payment-container">
                  <div className="row no-margin flex">
                     <div className="col l9 m8 s12">
                        <div className="col m12 l12 s12">
                           {renderAmountTable()}
                          <div className="row profile-row next-button-lock right">
                              <div className="navigate-buttons">
                                 <ReCaptcha
                                    sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                                    action="lock_licence_payment"
                                    verifyCallback={verifyCallback}
                                 />
                              </div>
                           </div>
                           <div className="row profile-row next-button-lock right">
                              <div className="navigate-buttons">
                                 {lockPaymentData && lockPaymentData.length>0 && <button
                                    type="button"
                                    disabled={
                                       ( !userContactData.contactId) 
                                       
                                    }
                                    className="waves-effect waves-light button-margin btn"
                                    onClick={() => displayPaymentPopup()}
                                 >
                                    Pay
                                 </button> }
                                 {(!lockPaymentData || lockPaymentData.length==0 ) &&  <div className="navigate-buttons">
                                     <div className="payment-details-section">
                                          <div className="placeholder-content">
                                             <ul>
                                                <li>There has been a problem loading the page, please try again later.</li>
                                                <li><button
                                       type="button"
                                       className="waves-effect waves-light button-margin btn"
                                       onClick={() => Navigator.toDashboard()}
                                    >
                                       HOME
                                    </button></li>
                                             </ul>
                                          </div>
                                       </div>
                                 </div>
                              }
                              </div>
                           </div>
                        </div>
                     </div>
                     {isOpenInfo && (
                        <RegistrationPaymentPopup
                           onChange={() => {
                              displayPaymentPopup();
                           }}
                           isModalOpen={isOpenInfo}
                           onWindcavePayment={getWindcavePayment}
                           onPolyPayment={getPoliPayment}
                        />
                     )}
                     {paymentFailed && (
                        <LockPaymentFailed
                           onChange={() => {
                              displayPaymentFailedPopup();
                           }}
                           isModalOpen={isPaymentFailedPopup}
                        />
                     )}
                  </div>
               </div>
            </div>
         </Loading>
      </main>
   );
};

const mapStateToProps = state => {
   return {
      userContactData: getUserInfoData(state.user),
      token: getToken(state),
      isFetchingPaymentUrl: isFetchingPaymentUrl(state),
      lockPaymentData: state.payment.paymentLockStatus || [],
      paymentDetails: state.payment.paymentDetails,
      isLoadingPage: state.payment.isLoading,
      isFetchingPaymentLock: isFetchingPaymentLock(state), // reusing existing selector
      isFetchingPaymentLockSuccess: isOperationSuccess('getPaymentLockRequest', state),
      isFetchingPaymentLockFailure: isOperationFailure('getPaymentLockRequest', state),
   };
};

const mapDispatchToProps = {
   getPaymentLockRequest: PaymentActions.getPaymentLockRequest,
   getPaymentUrlRequest: PaymentActions.getPaymentUrlRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(LockPayment);
